// extracted by mini-css-extract-plugin
export default {"container":"A+TLH","image":"_2xF0I","smallText":"oQEtu","textContainer":"Qnhx3","buttonWrapper":"BsO4i","button":"_6QU1r"};